export default "/assets/images/the-rookie-parent.d4fc327a80b158da.webp";